import { IUser } from '../shared/userlogs.model';
import { JsonPipe } from '@angular/common';
import { UserlogsService } from '../shared/userlogs.service';
import { Component, OnInit, Input } from '@angular/core';

import * as L from 'leaflet';

@Component({
  selector: 'app-dashboard-map',
  templateUrl: './dashboard-map.component.html',
  styleUrls: ['./dashboard-map.component.css']
})
export class DashboardMapComponent implements OnInit {

  @Input()
  users: IUser[];
  map: L.Map;
  circleMarkerOptions = <L.CircleMarkerOptions>{ color: 'blue', fillOpacity: 1, radius: 5 };

  constructor(private userlogs: UserlogsService, private jsonPipe: JsonPipe) { }

  ngOnInit() {
    this.map = L.map('dashboard-map').setView([10.762622, 106.660172], 14);

    L.tileLayer('http://map.thongtingiaothong.vn/traffic/{z}/{x}/{y}/withtext-background.png', {
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(this.map);


    this.users.forEach(l => {
      // l = this.userlogs.cleanData(l);
      const popupData = this.jsonPipe.transform(l);
      L.circleMarker([(<GeoJSON.Point>l.lastLoc).coordinates[1], (<GeoJSON.Point>l.lastLoc).coordinates[0]], this.circleMarkerOptions)
        .bindPopup(popupData)
        .addTo(this.map);
    });
  }

}



// WEBPACK FOOTER //
// /ng-app/src/app/dashboard/dashboard-map/dashboard-map.component.ts